// import React from "react";
// import CollectionsSection from "../../Component/Home/CollectionsSection";
// import ServicesSection from "../../Component/Home/ServicesSection";
// import SafetySection from "../../Component/Home/SafetySection";

// import Slider from "./Landingpage/Sliderss";

// const Landingpagess = () => {
//   return (
//     <>
    
//       <Slider />
//       <CollectionsSection />
//       <ServicesSection />
//       <SafetySection />
//       {/* <ExploreSection /> */}
//     </>
//   );
// };

// export default Landingpagess;


// Landingpagess.jsx
// Landingpagess.jsx
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import CollectionsSection from "../../Component/Home/CollectionsSection";
import ServicesSection from "../../Component/Home/ServicesSection";
import SafetySection from "../../Component/Home/SafetySection";
import Slider from "./Landingpage/Sliderss";
import Allinclusive from "./Allinclusive";

const Landingpagess = () => {
  const location = useLocation();

  // Handle scrolling to different sections based on state
  useEffect(() => {
    const scrollToSection = (sectionId) => {
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'start' 
          });
        }
      }, 100);
    };

    if (location.state?.scrollToCollections) {
      scrollToSection('collections-section');
      // Clear the state to prevent scrolling on subsequent visits
      window.history.replaceState({}, document.title);
    }
    
    if (location.state?.scrollToTestimonials) {
      scrollToSection('Testimonial-section');
      // Clear the state to prevent scrolling on subsequent visits
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  return (
    <>
      <Slider />
      <Allinclusive /> 
      <CollectionsSection /> {/* This should have id="collections-section" */}
      <ServicesSection />
      <SafetySection /> {/* This should have id="Testimonial-section" if that's where testimonials are */}
      {/* <ExploreSection /> */}
    </>
  );
};

export default Landingpagess;